import axiosInstance from './axiosInstance';

const INVENTORY_API_URL = '/inventory';

const inventoryService = {
  async generate(inventoryData) {
    try {
      const response = await axiosInstance.post(`${INVENTORY_API_URL}/generate.php`, inventoryData);
      return response.data;
    } catch (error) {
      console.error('Erro ao gerar inventário:', error);
      throw error;
    }
  }
};

export default inventoryService;

